import React, { Component } from "react";
import AntdCarousel, {CarouselProps} from 'antd/lib/carousel';
import 'antd/lib/carousel/style';

interface CProps extends CarouselProps {
  forwardedRef?: any;
};
class Carousel extends Component<CProps> {
    render() {
        const { forwardedRef, ...rest } = this.props;
        return (
          <AntdCarousel ref={forwardedRef} {...rest} />
        )
    }
}
export default React.forwardRef((props: CProps, ref) => {
    return (
      <Carousel {...props} forwardedRef={ref}>
        {props.children}
      </Carousel>
    )
});




// WEBPACK FOOTER //
// ./src/components/carousel/index.tsx